import(/* webpackMode: "eager", webpackExports: ["ClubsClient"] */ "/opt/buildhome/repo/src/components/clubs/clubs-client.tsx");
